<template>
  <button-component class="ReadMoreButton"
    :route="route"
    :label="label"
    :icon="icon"
    icon-on-right
    light
    small />
</template>

<script>
export default {
  name: 'ReadMoreButton',

  props: {
    route: {
      type: Object
    },
    label: {
      type: String,
      default: 'Read more'
    },
    icon: {
      type: String,
      default: 'arrow-down'
    }
  }
}
</script>

<style>
.ReadMoreButton {

}
</style>



// WEBPACK FOOTER //
// ReadMoreButton.vue?42c3efd9